const KEY = "sf_pending_plan";

export const setPendingPlan = (planKey) => sessionStorage.setItem(KEY, planKey);
export const peekPendingPlan = () => sessionStorage.getItem(KEY);
export const takePendingPlan = () => {
  const v = sessionStorage.getItem(KEY);
  if (v) sessionStorage.removeItem(KEY);
  return v;
};

// Where to send someone after signing in: back to Pricing if they were mid-purchase.
export const afterAuthPath = (role) => {
  if (role === "admin") return "/admin";
  return peekPendingPlan() ? "/#pricing" : "/account";
};
